import { render, staticRenderFns } from "./TermsFr.vue?vue&type=template&id=32c56e34"
import script from "./TermsFr.vue?vue&type=script&lang=js"
export * from "./TermsFr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports